import {
  Module
} from 'vuex'

import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import { TLightingSystemsState } from './types'
import { TRootState } from '../types'

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
} as Module<TLightingSystemsState, TRootState>
